module.exports = __webpack_public_path__ + "7aeee57777c1d597d4da11d36e827a35.svg";